export const dynamicPath = (path: string, params: Record<string, string> = {}) => {
  return Object.keys(params).reduce((accPath, key) => {
    return accPath.replace(`[${key}]`, params[key]);
  }, path);
};
